import React, { useState } from "react";
import { Button, Dropdown, Spinner } from "flowbite-react";
import { Dark } from "../../../../../Theme/Theme";
import "./AddSymbol.css";
import moment from "moment/moment";
import Backend from "../../../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function Options() {
  const [loading, setLoading] = useState(false);

  const [symbol, setSymbol] = useState("");
  const [date, setDate] = useState("");
  const [ltp, setLtp] = useState("");
  const [type, setType] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const addYear1 = moment().add(0, "y").format("YYYY");
  const addYear2 = moment().add(1, "y").format("YYYY");
  const addYear3 = moment().add(2, "y").format("YYYY");
  const addYear4 = moment().add(3, "y").format("YYYY");
  const addYear5 = moment().add(4, "y").format("YYYY");

  const addYear21 = moment().add(0, "y").format("YY");
  const addYear22 = moment().add(1, "y").format("YY");
  const addYear23 = moment().add(2, "y").format("YY");
  const addYear24 = moment().add(3, "y").format("YY");
  const addYear25 = moment().add(4, "y").format("YY");

  const addMonth1 = moment().add(0, "months").format("MMM");
  const addMonth2 = moment().add(1, "months").format("MMM");
  const addMonth3 = moment().add(2, "months").format("MMM");
  const addMonth4 = moment().add(3, "months").format("MMM");
  const addMonth5 = moment().add(4, "months").format("MMM");

  const submit = () => {
    if (!date) return toast.error("Select Date !");
    if (!ltp) return toast.error("Enter LTP !");
    if (!type) return toast.error("Select Type !");
    if (!month) return toast.error("Select Month !");
    if (!year) return toast.error("Select Year !");

    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol: symbol,
      date: date >= 10 ? date : "0" + date,
      month: month,
      year: year,
      type: type,
      ltp: ltp,
      mcx: symbol == "NIFTY" || symbol == "BANKNIFTY" ? 0 : 1,
    };

    backend.add_options(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success(r.message);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div className="flex flex-col justify-center items-center">
      {/* SYMBOL */}
      <div className="nseContainer border-2 border-[var(--hover)] ">
        <div className="nseItem label"> SYMBOL : </div>
        <div className="nseItem label">
          <Dropdown
            value={symbol}
            className="dropDown"
            label={symbol || "Select Symbol"}
            style={{ backgroundColor: Dark.primary }}
          >
            <Dropdown.Item onClick={() => setSymbol("")}>N/A</Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("NIFTY")}>
              NIFTY
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("BANKNIFTY")}>
              BANKNIFTY
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("GOLD")}>
              GOLD
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("SILVER")}>
              SILVER
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("CRUDEOIL")}>
              CRUDEOIL
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSymbol("COPPER")}>
              COPPER
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>

      {/* DATE */}
      <div className="nseContainer border-2 border-[var(--hover)]">
        <div className="nseItem label"> DATE : </div>
        <div className="nseItem label">
          <Dropdown
            value={date}
            className="dropDown"
            label={date || "Select Date"}
            style={{ backgroundColor: Dark.primary }}
          >
            <Dropdown.Item onClick={() => setDate("")}>N/A</Dropdown.Item>
            {[...new Array(31)].map((_, i) => (
              <Dropdown.Item key={i} onClick={() => setDate(i + 1)}>
                {i + 1}
              </Dropdown.Item>
            ))}
          </Dropdown>
        </div>
      </div>

      {/* MONTH */}
      <div className="nseContainer border-2 border-[var(--hover)]">
        <div className="nseItem label"> MONTH : </div>
        <div className="nseItem label">
          <Dropdown
            className="dropDown"
            label={month || "Select Month"}
            style={{ backgroundColor: Dark.primary }}
          >
            <Dropdown.Item onClick={() => setMonth("")}>N/A</Dropdown.Item>
            <Dropdown.Item onClick={() => setMonth(addMonth1)}>
              {addMonth1}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setMonth(addMonth2)}>
              {addMonth2}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setMonth(addMonth3)}>
              {addMonth3}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setMonth(addMonth4)}>
              {addMonth4}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setMonth(addMonth5)}>
              {addMonth5}
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>

      {/* YEAR */}
      <div className="nseContainer border-2 border-[var(--hover)]">
        <div className="nseItem label"> YEAR : </div>
        <div className="nseItem label">
          <Dropdown
            className="dropDown"
            label={year || "Select Year"}
            style={{ backgroundColor: Dark.primary }}
          >
            <Dropdown.Item onClick={() => setYear("")}>N/A</Dropdown.Item>
            <Dropdown.Item onClick={() => setYear(addYear21)}>
              {addYear1}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setYear(addYear22)}>
              {addYear2}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setYear(addYear23)}>
              {addYear3}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setYear(addYear24)}>
              {addYear4}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setYear(addYear25)}>
              {addYear5}
            </Dropdown.Item>
          </Dropdown>
        </div>
      </div>

      {/* TYPE (CE/PE) */}
      <div className="nseContainer border-2 border-[var(--hover)]">
        <div className="nseItem label"> TYPE : </div>
        <div className="nseItem label">
          <Dropdown
            className="dropDown"
            label={type || "Select Type"}
            style={{ backgroundColor: Dark.primary }}
          >
            <Dropdown.Item onClick={() => setType("")}>N/A</Dropdown.Item>
            <Dropdown.Item onClick={() => setType("CE")}>CE</Dropdown.Item>
            <Dropdown.Item onClick={() => setType("PE")}>PE</Dropdown.Item>
          </Dropdown>
        </div>
      </div>

      {/* LTP */}
      <div className="nseltp border-2 border-[var(--hover)]">
        <div className="nseItem label"> LTP : </div>
        <div className="nseItem label">
          <input
            type="text"
            placeholder="Enter LTP"
            className="input bg-gray-50 border h-8 border-gray-300 rounded-lg w-full p-2.5"
            value={ltp}
            onChange={(e) => setLtp(e.target.value)}
          />
        </div>
      </div>

      <div style={{ width: 300 }}>
        <Button
          onClick={!loading ? submit : null}
          className="w-full max-w-sm mt-4 text-white font-semibold !bg-[var(--primary)] hover:brightness-90 transition-all rounded-lg flex items-center justify-center text-center"
        >
          <div className="flex items-center justify-center gap-2">
            {loading && <Spinner size="sm" />}
            {!loading && "SUBMIT"}
          </div>
        </Button>
      </div>
    </div>
  );
}
